export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkWork: "nav-link-work",
  linkApproach: "nav-link-approach",
  linkStudio: "nav-link-studio",
  linkContact: "nav-link-contact",
  linkProjects: "nav-link-projects",
  projectItem: (slug) => `nav-project-${slug}`,
  cta: "nav-cta",
  mobileMenuToggle: "nav-mobile-toggle",
  mobileMenuPanel: "nav-mobile-panel",
  mobileProjectItem: (slug) => `nav-mobile-project-${slug}`,
  mobileLinkStudio: "nav-mobile-link-studio",
  mobileLinkContact: "nav-mobile-link-contact",
  mobileCta: "nav-mobile-cta",
};

export const HERO = {
  root: "hero",
  scrollCue: "hero-scroll-cue",
  title: "hero-title",
  canvas: "hero-canvas",
};

export const MANIFESTO = {
  root: "manifesto",
  chapter: (i) => `manifesto-chapter-${i}`,
};

export const STUDIO = {
  root: "studio",
  block: (slug) => `studio-block-${slug}`,
};

export const WORK = {
  root: "work",
  item: (slug) => `work-item-${slug}`,
  slide: (slug) => `work-slide-${slug}`,
};

export const CONTACT = {
  root: "contact",
  form: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  company: "contact-input-company",
  projectType: "contact-input-project-type",
  message: "contact-input-message",
  submit: "contact-submit",
  success: "contact-success",
};

export const FOOTER = {
  root: "footer",
};
